"use client";

import { useState } from "react";
import { Check, Link2 } from "lucide-react";

export function CopyJobLinkButton({ url, title }: { url: string; title: string }) {
  const [copied, setCopied] = useState(false);

  const handleShare = async () => {
    try {
      if (typeof navigator !== "undefined" && navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
        setCopied(true);
        window.setTimeout(() => setCopied(false), 2200);
        return;
      }
      if (typeof navigator !== "undefined" && navigator.share) {
        await navigator.share({ title, url });
      }
    } catch {
      // Ignore user cancellation
    }
  };

  return (
    <button
      type="button"
      onClick={handleShare}
      className="inline-flex h-10 items-center justify-center gap-1.5 rounded-[10px] border border-white/18 bg-white/[.06] px-3.5 text-xs font-semibold text-white transition hover:border-white/30 hover:bg-white/[.11]"
      aria-label="Copy link to this job"
    >
      {copied ? (
        <>
          <Check size={14} className="text-lime" aria-hidden="true" />
          <span className="text-lime">Link copied</span>
        </>
      ) : (
        <>
          <Link2 size={14} aria-hidden="true" />
          <span>Share role</span>
        </>
      )}
    </button>
  );
}
